export default {
      id: "ic-misc-profile-usage",
      viewBox: "0 0 29.7 26.7",
      url: "../dist/images/" + "sprite.svg#ic-misc-profile-usage",
      toString: function () {
        return this.url;
      }
    }